import React, {useState, useEffect} from 'react';
import './chartWidget.css'
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Sector } from 'recharts';


export default function ChartWidget() {
  const [data, setData] = useState([])

  const donorLength = data.filter(user => user.userDonor == 'true').length
  const notDonorLength = data.filter(user => user.userDonor == 'false').length

  const Apos = data.filter(user => user.userBloodGroup == 'A+ve').length
  const Aneg = data.filter(user => user.userBloodGroup == 'A-ve').length
  const Bpos = data.filter(user => user.userBloodGroup == 'B+ve').length
  const Bneg = data.filter(user => user.userBloodGroup == 'B-ve').length
  const ABpos = data.filter(user => user.userBloodGroup == 'AB+ve').length
  const ABneg = data.filter(user => user.userBloodGroup == 'AB-ve').length
  const Opos = data.filter(user => user.userBloodGroup == 'O+ve').length
  const Oneg = data.filter(user => user.userBloodGroup == 'O-ve').length

  useEffect(() => {
    fetch('https://blood147.000webhostapp.com/admin_panel/readUsers.php')
    .then((response) => response.json())
    .then((users) => setData(users))
    .catch((error) => console.log(error))
  }, []);

  const dataPie = [
    { name: 'donor', value: donorLength, fill: '#0088FE' },
    { name: 'not donor', value: notDonorLength, fill: '#00C49F' },
  ];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  // '#0088FE', '#00C49F', '#FFBB28', '#FF8042'

  const dataBar = [
    { name: 'A+ve', users: Apos},
    { name: 'A-ve', users: Aneg},
    { name: 'B+ve', users: Bpos},
    { name: 'B-ve', users: Bneg},
    { name: 'AB+ve', users: ABpos},
    { name: 'AB-ve', users: ABneg},
    { name: 'O+ve', users: Opos},
    { name: '0-ve', users: Oneg},
  ];

  return (
    <div className="barChart">
        <div className="barChartContainer">
          <div className="barChartWrapper">
            <h3 className="barTitle">
              Users Blood Groups Chart
            </h3>
            <div className="bar">
              <ResponsiveContainer width='100%' height='100%' >
                <BarChart data={dataBar}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="users" fill="#8884d8" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

        <div className="pieChartContainer">
          <div className="pieChartWrapper">
            <h3 className="pieTitle">
              Donors Chart
            </h3>
            <div className="pie">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart >
                  <Pie
                    data={dataPie}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={renderCustomizedLabel}
                    dataKey="value">
                  </Pie>
                  <Legend/>
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
  );
}
